document.addEventListener('DOMContentLoaded', () => {
  let nextPage = 2; // Start loading from the second page
  let isLoading = false;

  const loadMoreProducts = () => {
    if (isLoading) return; // Prevent duplicate requests
    isLoading = true;

    fetch(`${window.location.pathname}?view=load-more&page=${nextPage}`)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        const newProducts = html.querySelectorAll('.product-grid-image-container');
        const productGrid = document.querySelector('.product-grid');

        newProducts.forEach((product) => productGrid.appendChild(product));

        nextPage++;
        isLoading = false;

        // Reinitialize image loading for new images
        initializeImageLoading();

        // Stop further requests if no more products are loaded
        if (newProducts.length === 0) {
          window.removeEventListener('scroll', handleScroll);
        }
      })
      .catch((error) => {
        console.error('Error loading more products:', error);
        isLoading = false;
      });
  };

  const handleScroll = () => {
    // Use `document.documentElement` for cross-browser compatibility
    const scrollPosition = window.scrollY + window.innerHeight;
    const threshold = document.documentElement.scrollHeight - 1000; // Adjust threshold as needed

    console.log(`Scroll position: ${scrollPosition}, Threshold: ${threshold}`); // Debugging

    if (scrollPosition >= threshold) {
      loadMoreProducts();
    }
  };

  // Attach scroll event listener to the window
  window.addEventListener('scroll', handleScroll);
});